export enum INTEGRATION_ACTIONS {
  getIntegrations = 'integrations/getIntegrations',
  configureIntegration = 'integrations/configureIntegration',
  sendDocuSignRequest = 'integrations/sendDocuSignRequest',
  createShotflowInstance = 'integrations/createShotflowInstance',
  updateShotflowInstance = 'integrations/updateShotflowInstance',
  deleteShotflowInstance = 'integrations/deleteShotflowInstance'
}
